// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback, useEffect, useState } from 'react'
import { PageLoadingSpinner, PrimaryButton, useAdjustPageHeadEntities } from 'ui_kit_qmd'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import './intakeFormsViewMode.scss'
import { getIntakeForm, getPatientInfo } from '../../../../../store/charts/ChartsThunk'
import { useGetPatientsPatientIdQuestionnairesSessionId } from '@/api/generated/questionnaire/questionnaire'
import { QuestionTypeSelector } from './question-type-selector'
import { QuestionnaireAnswers } from './QuestionnaireAnswers'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../../../utils/errormessages'
import { PATIENT_CHARTS_PAGE_ROUTE, QUICK_MD_TITLE_TEXT } from '../../../../../utils/constants'
import { isEmpty, parseTimeZone, parseUserDateTime } from '../../../../../utils/common'
import { generateLoggIntakeFormData, postHIPAALogMessage } from '../../../../../utils/HippaLoggingHelper'
import { formatNameForPatientChartTitle } from '../../../helper'

const containerStyle = { width: '200px', height: '40px' }
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
const contentContainerStyle = { flexDirection: 'column' }
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
const breadcrumbsAdditionalContainerStyle = { marginTop: 8, position: 'relative', top: 0, left: 25 }

const IntakeFormsViewMode = memo(() => {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const patientId = searchParams.get('id')
  const intakeFormId = searchParams.get('intakeFormId')
  // Online/async visits have no intake form; they pass a questionnaire sessionId instead and we
  // render the questionnaire answers from the dedicated endpoint.
  const sessionId = searchParams.get('sessionId')
  const isQuestionnaire = Boolean(sessionId)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const patientInfo = useSelector((state) => state.chartsReducer.patientInfo[patientId] ?? {})

  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const loading = useSelector((state) => state.chartsReducer.loading)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const error = useSelector((state) => state.chartsReducer.error)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const intakeForm = useSelector((state) => state.chartsReducer.intakeForm)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const profile = useSelector((state) => state.accountSettings.adminProfile)

  const { data: questionnaireSession, isLoading: isQuestionnaireLoading } =
    useGetPatientsPatientIdQuestionnairesSessionId(patientId ?? '', sessionId ?? '', {
      query: { enabled: isQuestionnaire && Boolean(patientId) },
    })

  useEffect(() => {
    if (isQuestionnaire) return
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    dispatch(getIntakeForm({ patientId, intakeFormId }))
    postHIPAALogMessage(generateLoggIntakeFormData({ intakeFormId, patientId, userId: profile?.AdminId ?? '' }))
  }, [])
  const closeIntake = useCallback(() => navigate(`/patient-chart?id=${patientId}`), [navigate, patientId])

  const { Name, VisitTypeName, CompleteDateTime, Questions = [] } = intakeForm ?? {}
  const title = isQuestionnaire ? 'Online visit response' : Name
  const [userTimeZone, setUserTimeZone] = useState(parseTimeZone(profile.TimeZone))
  const CompleteDate = parseUserDateTime(CompleteDateTime, userTimeZone, false)

  const { FirstName, LastName } = patientInfo ?? {}
  const pageTitle = `${formatNameForPatientChartTitle(FirstName, LastName)} - Intake Form`
  const pageHeader = useAdjustPageHeadEntities({
    title: pageTitle,
  })
  useEffect(
    () => () => {
      document.title = QUICK_MD_TITLE_TEXT
    },
    [],
  )

  useEffect(() => {
    setUserTimeZone(parseTimeZone(profile.TimeZone))
  }, [profile])

  useEffect(() => {
    if (isEmpty(patientInfo) && !loading) {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      dispatch(getPatientInfo(patientId))
    }
  }, [dispatch, loading, patientId, patientInfo])

  if (error === getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, 'Patient')) {
    void navigate(PATIENT_CHARTS_PAGE_ROUTE)
  }
  if (isQuestionnaire ? isQuestionnaireLoading : loading) {
    return (
      <div className='flex h-screen items-center justify-center'>
        <PageLoadingSpinner />
      </div>
    )
  }

  return (
    <>
      {pageHeader}
      <div className='intake-questions-title-section'>
        <div className='intake-questions-title'>{title}</div>
        <div className='intake-questions-close-button'>
          <PrimaryButton btnText='Close intake' containerStyle={containerStyle} onPress={closeIntake} />
        </div>
      </div>

      <div className='intake-questions-wrap'>
        <div className='intake-questions-container'>
          {isQuestionnaire ?
            <QuestionnaireAnswers session={questionnaireSession} />
          : <div className='intake-questions-table'>
              <div className='intake-questions-item-container'>
                <div className='intake-questions-question'>Completed on: {CompleteDate}</div>
                <div className='intake-questions-answer'>{VisitTypeName}</div>
              </div>
              <hr className='intake-questions-divider' />
              {/*
               // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered */}
              {Questions.map((question, index) => (
                // eslint-disable-next-line react/no-array-index-key -- intake questions are a static ordered list with no stable id
                <QuestionTypeSelector key={index} question={question} index={index} />
              ))}
            </div>
          }
        </div>
      </div>
    </>
  )
})

export default IntakeFormsViewMode
